import React from 'react';
import { MenuItem } from '../../types/app.types';
import { List, ListItem, ListItemButton, ListItemText, Box, useTheme as useMuiTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface MenuListProps {
  items: MenuItem[];
  onSelect?: (path: string) => void;
  selectedId?: string;
}

export const MenuList: React.FC<MenuListProps> = ({ items, onSelect, selectedId }) => {
  const theme = useMuiTheme();

  const handleClick = (path: string) => {
    if (onSelect) {
      onSelect(path);
    }
  };

  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      py: 1,
    }}>
      <List sx={{ flex: 1, px: 1 }}>
        {items.map((item) => {
          const active = selectedId === item.id;
          return (
            <ListItem key={item.id} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                selected={active}
                onClick={() => handleClick(item.path)}
                sx={{
                  borderRadius: 1.5,
                  py: 1,
                  px: 2,
                  color: active ? theme.palette.primary.main : theme.palette.text.secondary,
                  backgroundColor: active ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
                  '&:hover': {
                    backgroundColor: active
                      ? alpha(theme.palette.primary.main, 0.12)
                      : theme.palette.action.hover,
                  },
                  '&.Mui-selected': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.primary.main, 0.12),
                    },
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: '0.875rem',
                    fontWeight: active ? 600 : 400,
                    color: active ? theme.palette.primary.main : theme.palette.text.secondary,
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
